import Api from '~/i18n/services/api.js';
import AutomatedTesting from '~/i18n/services/automated-testing.js';
import Aws from '~/i18n/services/aws.js';
import BackEndDevelopment from '~/i18n/services/back-end-development.js';
import ClientPortal from '~/i18n/services/client-portal.js';
import CustomerJourney from '~/i18n/services/customer-journey.js';
import DesignSprint from '~/i18n/services/design-sprint.js';
import DesignSystem from '~/i18n/services/design-system.js';
import FrontEndDevelopment from '~/i18n/services/front-end-development.js';
import Intranet from '~/i18n/services/intranet.js';
import Laravel from '~/i18n/services/laravel.js';
import MySql from '~/i18n/services/mysql.js';
import NativeApps from '~/i18n/services/native-apps.js';
import PenTest from '~/i18n/services/pentest.js';
import Php from '~/i18n/services/php.js';
import StrategySession from '~/i18n/services/strategy-session.js';
import UxResearch from '~/i18n/services/ux-research.js';
import VisualDesign from '~/i18n/services/visual-design.js';
import WireframingPrototyping from '~/i18n/services/wireframing-prototyping.js';
import UiUxDesign from '~/i18n/services/ui-ux-design.js';

export default {
    'automated-testing': AutomatedTesting,
    'back-end-development': BackEndDevelopment,
    'client-portal': ClientPortal,
    'customer-journey': CustomerJourney,
    'design-sprint': DesignSprint,
    'design-system': DesignSystem,
    'front-end-development': FrontEndDevelopment,
    'native-apps': NativeApps,
    'strategy-session': StrategySession,
    'ui-ux-design': UiUxDesign,
    'ux-research': UxResearch,
    'visual-design': VisualDesign,
    'wireframing-prototyping': WireframingPrototyping,
    api: Api,
    aws: Aws,
    intranet: Intranet,
    laravel: Laravel,
    mysql: MySql,
    pentest: PenTest,
    php: Php,
};
